import {
  CHANGE_ACCESS_LIMITED_MODAL_VISIBILITY_STATUS,
  DomainAccessModalActionTypes,
  DomainAccessModalDataState,
  HIDE_DOMAIN_ACCESS_MODAL,
  SET_MODAL_DATA
} from "./types";

const initialSettingsPanelState: DomainAccessModalDataState = {
  isDomainAccessModalOpen: false,
  accessName: "",
  showAccessLimitedModal: false
};

export const domainAccessModalReducer = (
  state = initialSettingsPanelState,
  action: DomainAccessModalActionTypes
): DomainAccessModalDataState => {
  switch (action.type) {
    case SET_MODAL_DATA:
      return {
        ...state,
        isDomainAccessModalOpen: action.meta.params.isDomainAccessModalOpen,
        accessName: action.meta.params.accessName
      };
    case HIDE_DOMAIN_ACCESS_MODAL:
      return {
        ...state,
        isDomainAccessModalOpen: false
      };
    case CHANGE_ACCESS_LIMITED_MODAL_VISIBILITY_STATUS:
      return {
        ...state,
        showAccessLimitedModal: action.meta.params.showAccessLimitedModal
      };
    default:
      return state;
  }
};
